import {Schema, useUrlFilters} from '../useUrlFilters';
import {SelectedInputGroup} from './types/filters.type';

export interface BuyersListingFilters {
  search: string;
  input_guid: SelectedInputGroup[];
  order_by: string;
  has_immediate: boolean;
}

const defaultSchema: Schema<BuyersListingFilters> = {
  search: {type: 'string', default: ''},
  input_guid: {type: 'json', default: []},
  order_by: {type: 'string', default: ''},
  has_immediate: {type: 'boolean', default: false},
};

export function useBuyersListingFilters() {
  const {values, setFilter, setFilters, resetFilter, reset} =
    useUrlFilters<BuyersListingFilters>(defaultSchema);

  return {
    buyersFilters: values,
    setBuyersFilter: setFilter,
    setBuyersFilters: setFilters,
    resetFilter,
    buyersReset: reset,
  };
}
